var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCharger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 155,
    height: 330.725,
    viewBox: "0 0 155 330.725",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_26108"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.161,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "charger",
    transform: "translate(-0.189 -0.467)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26107",
    "data-name": "Rectangle 26107",
    width: 130.525,
    height: 24.101,
    transform: "translate(12.247 307.091)",
    fill: "#332c33"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_144535",
    "data-name": "Group 144535",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_144534",
    "data-name": "Group 144534",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26130",
    "data-name": "Rectangle 26130",
    width: 155,
    height: 311,
    rx: 8,
    transform: "translate(0.189 0.467)",
    fill: "#465c85"
  }), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26108-2",
    "data-name": "Rectangle 26108",
    width: 115.986,
    height: 82.978,
    transform: "translate(19.189 29.602)",
    fill: "#332c33"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0.19, 0.47)",
    filter: "url(#Rectangle_26108)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26108-3",
    "data-name": "Rectangle 26108",
    width: 115.986,
    height: 82.978,
    transform: "translate(19 29.14)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_144533",
    "data-name": "Group 144533",
    transform: "translate(30.519 66.409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_144532",
    "data-name": "Group 144532"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_144545",
    "data-name": "Group 144545",
    transform: "translate(12.977)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26109",
    "data-name": "Rectangle 26109",
    width: 9.3,
    height: 14.474,
    transform: "translate(48.726 5.763)",
    fill: "#00ffd5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26110",
    "data-name": "Rectangle 26110",
    width: 9.3,
    height: 14.474,
    transform: "translate(35.693 5.763)",
    fill: "#00ffd5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26111",
    "data-name": "Rectangle 26111",
    width: 9.3,
    height: 14.474,
    transform: "translate(22.726 5.763)",
    fill: "#00ffd5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26112",
    "data-name": "Rectangle 26112",
    width: 9.3,
    height: 14.474,
    transform: "translate(9.693 5.763)",
    fill: "#00ffd5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(60.34 177.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "flash",
    d: "M376.918,413.867H363.134a2.024,2.024,0,0,1-1.567-3.305l27.194-33.24a2.023,2.023,0,0,1,3.5,1.876l-6.924,22.521h13.785a2.023,2.023,0,0,1,1.567,3.305l-27.2,33.234a2.024,2.024,0,0,1-3.5-1.876Z",
    transform: "translate(-361.11 -376.579)",
    fill: "#00ffd5",
    fillRule: "evenodd"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharger);
export default __webpack_public_path__ + "static/media/charger.ddaec840678513daf7e23f4f1677a8e3.svg";
export { ForwardRef as ReactComponent };